import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import './UserApprovalModal.css';

const UserApprovalModal = ({ onClose }) => {
  const [pendingUsers, setPendingUsers] = useState([]);

  const getBackendUrl = () => {
    return window.location.hostname === 'localhost'
      ? process.env.REACT_APP_BACKEND_URL_LOCAL
      : process.env.REACT_APP_BACKEND_URL_PRODUCTION;
  };

  useEffect(() => {
    const fetchPendingUsers = async () => {
      try {
        const response = await axios.get(`${getBackendUrl()}/api/admin/pending-users`);
        setPendingUsers(response.data);
      } catch (error) {
        Swal.fire('Error', 'Failed to fetch pending users', 'error');
      }
    };
    fetchPendingUsers();
  }, []);

  const handleApprove = async (userId) => {
    try {
      await axios.post(`${getBackendUrl()}/api/admin/approve-user/${userId}`);
      setPendingUsers(pendingUsers.filter(user => user._id !== userId));
      Swal.fire('Success', 'User approved successfully', 'success');
    } catch (error) {
      Swal.fire('Error', 'Failed to approve user', 'error');
    }
  };

  const handleReject = async (userId) => {
    try {
      const response = await axios.post(`${getBackendUrl()}/api/admin/reject-user/${userId}`);
      if (response.status === 200) {
        setPendingUsers(pendingUsers.filter(user => user._id !== userId));
        Swal.fire('Success', 'User rejected successfully', 'success');
      } else {
        Swal.fire('Error', 'Failed to reject user', 'error');
      }
    } catch (error) {
      console.error('Error rejecting user:', error);
      Swal.fire('Error', 'Failed to reject user', 'error');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Pending Users</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {pendingUsers.map(user => (
              <tr key={user._id}>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <button onClick={() => handleApprove(user._id)}>Approve</button>
                  <button onClick={() => handleReject(user._id)}>Reject</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default UserApprovalModal;